import { useQuery } from 'react-query';
import axios from 'axios';
import { UsersDto } from '../models/user';

const getUsers = async (): Promise<UsersDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}user/Index`);
  return data;
};

// item 244 — `enabled` lets a caller defer the fetch (e.g. the approval wizard only
// needs the user list for the project-lead step, which is hidden below the $1k floor).
// Defaults to true so every existing caller is unaffected.
const useUsers = (enabled = true) => useQuery('users', getUsers, { enabled });

export default useUsers;
